import React from 'react';
import TaskCategoryTable from './TaskCategoryTable';
import { CustomModal } from '../../../revampComponents/Atom/Modals';
import { KonfhubButton } from '../../../revampComponents/Atom/Buttons';
import FormButtons from '../../../revampComponents/Molecule/Buttons/FormButtons';
import { useFormik } from 'formik';
import * as Yup from "yup";

export const CategorySetting = ({
    isOpen = false,
    onClose = () => { },
    mode = "add", 
    initialData = null,
    onSubmit = () => { },
    loading = false,
    categories = [],
    onEdit = () => { },
    onDelete = () => { },
    onReorder = () => { },
    onCreateNew = () => { }
}) => {
    const formik = useFormik({
        initialValues: {
            category_name: initialData?.category_name || "",
        },
        validationSchema: Yup.object({
            category_name: Yup.string()
                .required("Category name is required")
                .max(200, "Maximum 200 characters allowed"),
        }),
        onSubmit: (values) => {
            onSubmit(values);
        },
        enableReinitialize: true,
    });

    if (mode === 'table') {
        return (
            <CustomModal
                width="830px"
                customStyles={{ overflow: "inherit" }}
                overflow="visible"
                openModal={isOpen}
                setOpenModal={onClose}
                content={
                    <>
                        <div className="px-3">
                            <div className="d-flex justify-content-between align-items-center my-3">
                                <h6 className="mb-0">Categories</h6>
                                <KonfhubButton
                                    btnType="primary"
                                    onClick={onCreateNew}
                                >
                                    Add Category
                                </KonfhubButton>
                            </div>

                            <TaskCategoryTable
                                data={categories}
                                isLoading={loading}
                                onEdit={onEdit}
                                onDelete={onDelete}
                                onReorder={onReorder}
                            />
                        </div>
                    </>
                }
            />
        );
    }

    return (
        <CustomModal
            width="700px"
            customStyles={{ overflow: "inherit" }}
            overflow="visible"
            openModal={isOpen}
            setOpenModal={onClose}
            header={mode === "add" ? "Create Category" : "Edit Category"}
            content={
                <>
                    <div className="px-3 ">
                        <div className="mb-4">
                            <label className="label" htmlFor="category_name">
                                Category Name
                                <span className="text-danger"> *</span>
                            </label>
                            <div className="mt-2">
                                <input
                                    type="text"
                                    className={
                                        formik?.errors?.category_name && formik?.touched?.category_name
                                            ? "input border-danger box-shadow-none w-100"
                                            : "input w-100"
                                    }
                                    onBlur={formik?.handleBlur}
                                    placeholder="Enter category name"
                                    id="category_name"
                                    name="category_name"
                                    value={formik?.values?.category_name}
                                    onChange={formik?.handleChange}
                                    maxLength={200}
                                />
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-1">
                                <div>
                                    {formik?.errors?.category_name && formik?.touched?.category_name && (
                                        <p className="text-danger mb-0 small">
                                            {formik?.errors?.category_name}
                                        </p>
                                    )}
                                </div>
                                <p className="text-muted small mb-0">
                                    Maximum Character: 200
                                </p>
                            </div>
                        </div>
                    </div>

                    <FormButtons
                        saveBtnContent={mode === "add" ? "Save" : "Save"}
                        isLoading={loading}
                        saveBtnDisabled={!formik.dirty || loading || !formik.isValid}
                        cancelBtnContent="Cancel"
                        onSave={() => {
                            formik?.submitForm();
                        }}
                        onCancel={() => {
                            onClose();
                        }}
                    />
                </>
            }
        />
    );
};



